import { createFileRoute } from '@tanstack/react-router'
import { ExpenseStatementPage, type ExpenseStatementSearch } from '../../../components/expenses/ExpenseStatementPage'

const DATE = /^\d{4}-\d{2}-\d{2}$/

/**
 * The expense statement (spec 2026-10-22-01): spend by expense category (or
 * account) and by site or building. Every choice lives in the URL, so a
 * statement can be bookmarked and sent.
 */
export const Route = createFileRoute('/$org/expenses/statement')({
  component: ExpenseStatementPage,
  validateSearch: (search: Record<string, unknown>): ExpenseStatementSearch => ({
    from: typeof search.from === 'string' && DATE.test(search.from) ? search.from : undefined,
    to: typeof search.to === 'string' && DATE.test(search.to) ? search.to : undefined,
    site: search.site ? String(search.site) : undefined,
    building: search.building ? String(search.building) : undefined,
    view: search.view === 'accounting' ? 'accounting' : undefined,
    regime: search.regime === 'current' || search.regime === 'works' ? search.regime : undefined,
    amount: search.amount === 'ht' ? 'ht' : undefined,
  }),
})
